"use client"

import { HomeLanding } from "@/components/home/home-landing"

export default function HomePage() {
  return <HomeLanding />
}
